import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/CartItem.css"; // external CSS for styling

export default function CartItem({ item, removeFromCart }) {
  const navigate = useNavigate(); // Hook for navigation

  return (
    <div className="cart-item">
      <div className="image-wrapper">
        <img
          src={item.image}
          alt={item.name}
        />
      </div>

      <div className="card-content">
        <h3>{item.name}</h3>

        <p className="description" >
          {item.description || "No description available."}
        </p>

        <div className="price-box">
          ₹{item.price} <span>/ Day</span>
        </div>

        <ul className="features">
          {item.features?.map((feature, index) => (
            <li key={index}>✔ {feature}</li>
          )) || <li>No additional features.</li>}
        </ul>

        <button
          className="remove-btn"
          onClick={() => navigate("/contact")}
        >
          Enquiry
        </button>
      </div>
    </div>
  );
}